export const GITHUB_TO_SLACK: Record<string, string> = {
	'Abdullah-146': 'Sh Abdullah',
	'abhiparajuli-myaifrontdesk': 'Abhishek',
	AhsanAshfaq1: 'Ahsan',
	googlebaba01: 'Gajendra Nagar',
	hassannaftabb: 'Hassan',
	himanshuhsr: 'Himanshu Raj',
	igurisandhu: 'Gurjeet Singh',
	iharshk: 'Harsh Kesharwani',
	mordhawaj: 'K Mordhwaj',
	'pardhu-nadella': 'Pardhu Nadella',
	RuchirB: 'ruchir',
	Suleman12723: 'Suleman Sohail',
	tayyabferozi: 'Tayyab Ferozi',
};
